import { Currency } from '@/constants/currency'
import { api } from '@/lib/api'

import { Contract } from '../types'

type AmendContractRequest = {
  contractId: string
  contractDetails: {
    contractorRole: string
    scopeOfWork: string
    paymentDetails?: {
      currency?: Currency
      amount?: string
      frequency?: string
      dayType?: string
      day?: string
    }
  }
}

export function amendContract(data: AmendContractRequest) {
  return api.post<Contract>(`/v1/me/contract-amendments`, data)
}
